<template>
  <div class="h-md-popreply">
    <a-popover
      placement="topLeft"
      trigger="click"
      :title="title"
      @visibleChange="visibleChange"
    >
      <template slot="content">
        <div class="h-md-popover-content">
          <a-input
            class="md-h-textarea"
            v-model="commentsContents"
            type="textarea"
          />
          <div class="md-h-btn">
            <span @click="submitReply">{{ submitText }}</span>
          </div>
        </div>
      </template>
      <span class="handle-btn">{{ text }}</span>
    </a-popover>
  </div>
</template>
<script>
export default {
  props: ["recordItem", "text"],
  data() {
    return {
      replyVisible: false,
      commentsContents: "",
      submitText: "",
      title: "",
    };
  },
  mounted() {
    if (this.text == "回复") {
      this.submitText = "提交";
      this.title = "回复意见";
    } else {
      this.submitText = "保存";
      this.title = "编辑内容";
    }
  },
  methods: {
    submitReply() {
      if (this.recordItem.roleIds && this.text == "回复") {
        console.log("主消息回复");
        this.addComments(this.recordItem.infoId);
      } else if (this.recordItem.messageType && this.text == "回复") {
        console.log("消息列表回复");
        this.addComments(this.recordItem.bid, this.recordItem.parentId);
      } else if (this.text == "回复") {
        this.addComments(this.recordItem.infoId, this.recordItem.id);
      } else {
        console.log("子消息编辑");
        this.editComments();
      }
    },
    addComments(infoId, parentId) {
      this.$post(
        "md/addComments",
        {
          contents: this.commentsContents,
          infoId: infoId,
          parentId: parentId,
        },
        {
          "Content-Type": "application/json",
        }
      ).then(
        (res) => {
          if (res.data.code == 1) {
            this.$message.success("提交成功");
            this.$emit("update");
          } else {
            this.$message.error(res.data.message);
          }
        },
        () => {
          this.$message.error("提交失败");
        }
      );
    },
    editComments() {
      this.$post(
        "md/editComments",
        {
          contents: this.commentsContents,
          infoId: this.recordItem.infoId,
          parentId: this.recordItem.parentId,
          id: this.recordItem.id,
        },
        {
          "Content-Type": "application/json",
        }
      ).then(
        (res) => {
          if (res.data.code == 1) {
            this.$message.success("保持成功");
            this.$emit("update");
          } else {
            this.$message.error(res.data.message);
          }
        },
        () => {
          this.$message.error("保持失败");
        }
      );
    },
    visibleChange(visible) {
      this.replyVisible = false;
      console.log("this.dddd", this.recordItem);
      if (visible && this.text != "回复") {
        this.commentsContents = this.recordItem.contents;
      } else if (this.recordItem.messageType) {
        this.setRead(this.recordItem.id);
      }
    },
    setRead(ids) {
      if (ids) {
        this.$put("/message", {
          ids: ids,
        }).then((res) => {
          console.log("消息通知已读成功");
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h-md-popreply {
  display: inline-block;
  margin-left: 10px;
  .handle-btn {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(66, 142, 247, 1);
    cursor: pointer;
    margin-left: 10px;
  }
}
.h-md-popover-content {
  width: 320px;
  .md-h-textarea {
    margin: 5px 0 10px 0;
  }
  .handle-btn {
    cursor: pointer;
  }
  .md-h-btn {
    text-align: right;
    color: #428ef7;
    span {
      margin: 0 5px;
      cursor: pointer;
    }
  }
}
</style>